import { gql } from '@grandvisionhq/graphql';

const savedUserDetails = gql`
  fragment SavedUserDetailsFragment on Customer {
    email
    personalDetails {
      dateOfBirth
      firstName
      lastName
      middleName
      phone
      salutation
    }
    optIns {
      value
      uiType
      literalText
      id
    }
    defaultBillingAddress {
      additionalAddressInfo
      additionalStreetInfo
      city
      company
      country
      firstName
      lastName
      middleName
      postalCode
      prefix
      region
      salutation
      streetName
      streetNumber
    }
  }
`;

export { savedUserDetails };
//# sourceMappingURL=saved-user-details.js.map
